import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useState } from "react";
import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import { useCatalogEmptyStateTranslations, useLazyCoursesByCategory } from "../hooks";
import { useFilteredCategories } from "../hooks/useFilteredCategories";
import { CatalogEmptyStateContext } from "./CatalogEmptyStateContext";
import { jsx as _jsx } from "react/jsx-runtime";
export var CatalogEmptyStateContextProvider = function CatalogEmptyStateContextProvider(_ref) {
  var children = _ref.children,
    source = _ref.source,
    className = _ref.className;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCategory = _useState2[0],
    setSelectedCategory = _useState2[1];
  var _useFilteredCategorie = useFilteredCategories(),
    categories = _useFilteredCategorie.categories,
    isLoadingAllCategories = _useFilteredCategorie.isLoadingAllCategories;
  var _useCatalogEmptyState = useCatalogEmptyStateTranslations(),
    languageCode = _useCatalogEmptyState.languageCode;
  var _useLazyCoursesByCate = useLazyCoursesByCategory(),
    fetchCourses = _useLazyCoursesByCate.fetchCourses,
    currentCourses = _useLazyCoursesByCate.courses,
    isLoadingCourses = _useLazyCoursesByCate.loading,
    totalCoursesByCurrentCategory = _useLazyCoursesByCate.totalCount;
  var selectCategories = useCallback(function (value) {
    setSelectedCategory(value);
    void fetchCourses({
      pageSize: 4,
      languageCode: languageCode,
      categoryName: value === null || value === void 0 ? void 0 : value.value.slug
    });
  }, [fetchCourses, languageCode]);
  var catalogLink = createUrlWithSourceQueryParams({
    url: "/cursos-online/?all=true",
    source: source,
    sourceDetail: 'Catalog Empty State Title'
  });
  var currentCatalogByCategoryLink = useMemo(function () {
    var url = selectedCategory ? selectedCategory.value.absoluteUrl : "/cursos-online/?all=true";
    return createUrlWithSourceQueryParams({
      url: url,
      source: source,
      sourceDetail: 'Catalog Empty State Results'
    });
  }, [selectedCategory, source]);
  var allCategories = useMemo(function () {
    return categories.map(function (category) {
      return {
        id: String(category.originalId),
        label: category.name,
        value: category
      };
    });
  }, [categories]);
  useEffect(function () {
    if (allCategories.length && !selectedCategory) {
      void fetchCourses({
        pageSize: 4,
        languageCode: languageCode,
        categoryName: undefined
      });
    }
  }, [allCategories.length, fetchCourses, languageCode, selectedCategory]);
  var value = {
    source: source,
    className: className,
    currentCatalogByCategoryLink: currentCatalogByCategoryLink,
    selectCategory: selectCategories,
    catalogLink: catalogLink,
    allCategories: allCategories,
    isLoadingAllCategories: isLoadingAllCategories,
    totalCoursesByCurrentCategory: totalCoursesByCurrentCategory,
    currentCourses: currentCourses,
    isLoadingCourses: isLoadingCourses,
    selectedCategory: selectedCategory
  };
  return /*#__PURE__*/_jsx(CatalogEmptyStateContext.Provider, {
    value: value,
    children: children
  });
};